module.exports = __webpack_public_path__ + "static/media/flower-daffodil.0ecb44c2.svg";